import {dispatchEvent} from "fg-frontend/src/lib/dom";

/**
 * confirm popup
 *  - triggers custom events on window:
 *      confirmPopupShow
 *      confirmPopupHide
 *  */
export default (props, e) => {
  const {
    espClassName,
    messages,
  } = props;
  let self = e.target;


  if (!self.getAttribute('data-confirm-popup')) {
    e.preventDefault();

    dispatchEvent(window, 'confirmPopupShow');


    const messageConfirm = document.querySelector("#messageConfirm");
    const messageConfirmTargetType = messageConfirm.querySelector(".message-confirm__right--1");
    const messageConfirmPushNotification = messageConfirm.querySelector(".message-confirm__right--2");
    const messageConfirmConfirmationRequired = messageConfirm.querySelector(".message-confirm__right--3");
    const pushNotification = document.querySelector("input[name='frm.pushNotification']");
    const targetType = document.querySelector("input[name='frm.targetType']:checked");
    const confirmationRequired = document.querySelector("input[name='frm.confirmationRequired']");


    let messageTT = "Všetkým zamestnancom";
    if(targetType) {
      switch (targetType.value) {
        case 'BRANCH':
          messageTT = "Na vybrané odberné miesta";
          break;
        case 'EMPLOYEE':
          messageTT = "Vybraným zamestnancom";
          break;
      }
    } else {
      messageTT = "Zamestnancovi";
    }

    messageConfirmTargetType.innerHTML = "<b>" + messageTT + "</b>";
    messageConfirmPushNotification.innerText = pushNotification.checked ? 'aktívne' : 'neaktívne';
    messageConfirmConfirmationRequired.innerText = confirmationRequired.checked ? 'aktívne' : 'neaktívne';

    edeeshopPopup._buildTexts = function(messages, classNames, svgIcon) {
      var result = `<h2 class="${classNames.TITLE}">${messages.title}<span class="js_esp-custom-close"><svg class="svg-icon"><use xlink:href="/img/svg/svg-sprite.svg#close-thin"></use></svg></span></h2>`;
      result += `<div class="${classNames.TEXT}">${messageConfirm.innerHTML}</div>`;
      result += `<p class="${classNames.BTN_C}"></p>`;
      return result;
    };

    edeeshopPopup.createConfirm({
      confirmClassName: 'message-confirm',
      messages: {
        title: 'Potvrďte odoslanie správy',
        confirmButton: 'Odoslať',
        declineButton: 'Späť'
      },
      action: function (response, data, trigger) {

        dispatchEvent(window, 'confirmPopupHide');

        if (response == 'confirm') {
          self.setAttribute('data-confirm-popup', 'true');
          console.log(self);
          self.click();
        }
        else {
          self.removeAttribute('data-confirm-popup');
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/webActions/confirmPopupMessage.js